export const formatDate = ({ date, locale, withDay, shortFormat, }) => {
    if (!Date.parse(date)) {
        return;
    }
    if (shortFormat) {
        return new Date(date).toISOString().split('T')[0];
    }
    return new Intl.DateTimeFormat(locale, {
        day: withDay ? 'numeric' : undefined,
        year: 'numeric',
        month: 'long',
    }).format(new Date(date));
};
export const getIndiceYear = (date) => {
    return date.substring(0, 4);
};
